import * as React from 'react';

export default function Language(props) {
  const { width = 150, height = 150, primary } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 100 100">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_3367"
            data-name="Rectangle 3367"
            width="100"
            height="100"
            transform="translate(160 38)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_1609"
        data-name="Mask Group 1609"
        transform="translate(-160 -38)"
        clipPath="url(#clip-path)">
        <g id="language" transform="translate(160 38.001)">
          <path
            id="primary"
            d="M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z"
            fill={primary}
            opacity="0.3"
          />
          <path
            id="primary-2"
            data-name="primary"
            d="M4.813,13.94H16.1L-4.679-32.526H-15.3L-36.011,13.94h11.019l4.116-9.957H.7ZM-17.425-4.182l7.368-17.79,7.368,17.79Z"
            transform="translate(44.912 48.991)"
            fill={primary}
          />
          <path
            id="Path_63000"
            data-name="Path 63000"
            d="M9.548-25.9c-6.276.336-14.345.616-24.095.784.224-1.793.56-3.586.948-5.379l-5.716-1.233c-.448,2.241-.841,4.483-1.121,6.724-4.595,0-9.526.056-14.793.056l.056,5.379c4.931,0,9.638-.056,14.121-.056-.224,2.241-.392,4.539-.448,6.836A26.534,26.534,0,0,0-28.167-9.15c-5.323,3.866-7.957,8.461-7.957,13.728a10.092,10.092,0,0,0,2.638,7.341,9.2,9.2,0,0,0,6.892,2.746c7.341,0,13.5-3.754,18.547-11.151A58.7,58.7,0,0,0-2.107-8.814,14.022,14.022,0,0,1,.583-7.638C3.72-5.844,5.289-3.323,5.289-.017A9.616,9.616,0,0,1,.863,8.332c-2.69,1.737-6.724,2.97-12.155,3.642l2.017,5.043c6.724-.9,11.711-2.634,15.017-5.155,3.586-2.8,5.379-6.724,5.379-11.879A13.2,13.2,0,0,0,4.845-11.5,19.31,19.31,0,0,0-.478-14.025c.224-.9.5-1.793.728-2.69L-5.3-18c-.224,1.009-.5,1.961-.784,2.914-.672-.056-1.4-.056-2.073-.056a39.639,39.639,0,0,0-7.453.672c.112-1.793.224-3.534.392-5.267,9.918-.168,18.267-.448,25.1-.841ZM-7.767-9.763A49.871,49.871,0,0,1-13.034.6c-.672.9-1.293,1.737-1.905,2.522a81.09,81.09,0,0,1-.784-12.047,32.594,32.594,0,0,1,7.565-.841ZM-21.551-6.737A79.828,79.828,0,0,0-20.038,7.548a13.434,13.434,0,0,1-6.556,1.793c-2.522,0-3.754-1.625-3.754-4.763,0-3.642,2.069-6.9,6.276-9.806a18.774,18.774,0,0,1,2.522-1.517Z"
            transform="translate(76.754 70.288)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
